import { render, staticRenderFns } from "./PlatformStatusProcessAction.vue?vue&type=template&id=59736558"
import script from "./PlatformStatusProcessAction.vue?vue&type=script&lang=js"
export * from "./PlatformStatusProcessAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports